import { usageLabel, channelLabel } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { StatusBadge } from "@/components/StatusBadge";
import { ShieldCheck, Brush, Lock, Clock } from "lucide-react";

export const BookingJobSummary = ({ booking }) => (
  <>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h2 className="font-display text-2xl">{booking.job?.title}</h2>
        <p className="text-sm text-muted-foreground">
          {booking.model_name} · requested by {booking.client_company_name}
        </p>
      </div>
      <StatusBadge status={booking.status} />
    </div>
    <p className="text-sm leading-relaxed">{booking.job?.description}</p>
    <div className="flex flex-wrap gap-1.5">
      <Badge variant="secondary" className="rounded-full text-[10px]">{usageLabel(booking.job?.usage_type)}</Badge>
      <Badge variant="secondary" className="rounded-full gap-1 text-[10px]">
        <Clock className="h-3 w-3" /> {booking.job?.duration_months} month{booking.job?.duration_months > 1 ? "s" : ""}
      </Badge>
      {booking.job?.exclusivity && (
        <Badge variant="secondary" className="rounded-full gap-1 text-[10px]"><Lock className="h-3 w-3" /> exclusive</Badge>
      )}
      <Badge variant="secondary" className="rounded-full gap-1 text-[10px]">
        <Brush className="h-3 w-3" /> retouching {booking.job?.retouching_requested ? "requested" : "not requested"}
      </Badge>
      <Badge variant="secondary" className="rounded-full gap-1 text-[10px]">
        <ShieldCheck className="h-3 w-3 text-[hsl(174,38%,34%)]" /> AI screened · {booking.ethics?.risk_level} risk
      </Badge>
    </div>
    {(booking.job?.media_channels || []).length > 0 && (
      <div data-testid="booking-media-channels" className="rounded-xl border border-[hsl(174,38%,70%)] bg-[hsl(174,38%,96%)] p-3">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-[hsl(174,45%,22%)]">
          Licensed media — agreement limited to these channels only
        </p>
        <div className="mt-1.5 flex flex-wrap gap-1.5">
          {booking.job.media_channels.map((c) => (
            <Badge key={c} variant="outline" className="rounded-full border-[hsl(174,38%,60%)] bg-card text-[10px]">
              {channelLabel(c)}
            </Badge>
          ))}
        </div>
      </div>
    )}
    {booking.ethics?.required_consents?.length > 0 && (
      <div className="rounded-xl bg-muted p-3 text-xs text-muted-foreground">
        <span className="font-semibold text-foreground">Consent flags:</span>{" "}
        {booking.ethics.required_consents.join(" · ")}
      </div>
    )}
  </>
);
